import { YAMS_HOSTS } from './constants';
/**
 * Checks if a URL is a valid YAMS URL by comparing its hostname with ones on a predefined list of {@link YAMS_HOSTS}
 * @param url - check URL
 * @returns True if it is a valid YAMS URL
 */
export const isValidYamsUrl = (url) => YAMS_HOSTS.find(hostname => url.hostname === hostname) !== undefined;
